import { api } from 'api';
import { State, Store } from 'store/types';
import { GlobalEvents } from '../global';
import { FETCH_COLLECTION_INFO, FETCH_COLLECTIONS } from './collections-constants';
import { CollectionInfo, RequestCollectionListConfig, ResponseCollectionList } from './collections-types';

/**
 * Загрузка информации о коллекции
 * @param store
 * @param {string} url
 * @param {Record<string, string>} data
 * @returns {Promise<Collection[]>}
 */
export const getCollectionInfo = (store: Store, url: string, data: Record<string, string>) => {
  const { apiKey, orchestratorHost, useCredentials, requestID } = store.get();

  return api.get<CollectionInfo>(url, data, {
    orchestratorHost,
    useCredentials,
    apiKey,
    requestID,
  });
};

/**
 * Экшен загрузки информации о коллекции
 * @param {Store} store
 * @param {string} url
 * @param {string} productName
 * @param {string} [facade]
 * @returns {Promise<State>}
 */
export const loadCollectionInfoAction = (
  store: Store,
  url: string,
  productName: string,
  facade?: string
) =>
  new Promise<State>(resolve => {
    const { modelJson } = store.get();
    if (!modelJson.model) {
      resolve(store.get());
      return;
    }

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      useCredentials: process.env.USE_CREDENTIALS === '1',
      apiKey: process.env.API_KEY,
    });

    store.dispatch(FETCH_COLLECTION_INFO.init, { url, productName, ...(facade && { facade }) });

    const unsub = store.on('@dispatch', state => {
      if (state.collections.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });

/**
 * Загрузка списка коллекций
 * @param store
 * @param {string} url
 * @param {RequestCollectionListConfig} data
 * @returns {Promise<ResponseCollectionList>}
 */
export const getCollectionList = (store: Store, url: string, data: RequestCollectionListConfig) => {
  const { apiKey, orchestratorHost, useCredentials, requestID } = store.get();

  return api.get<ResponseCollectionList>(url, data, {
    orchestratorHost,
    useCredentials,
    apiKey,
    requestID,
  });
};

/**
 * Экшен загрузки списка коллекций
 * @param {Store} store
 * @param {string} url
 * @param {string} [variantId]
 * @param {string} [limit]
 * @param {string} [landingType]
 * @returns {Promise<State>}
 */
export const loadCollectionListAction = (
  store: Store,
  url: string,
  variantId?: string,
  limit?: string,
  landingType?: string
) =>
  new Promise<State>(resolve => {
    const { modelJson } = store.get();
    if (!modelJson.model) {
      resolve(store.get());
      return;
    }

    store.dispatch(GlobalEvents.setRequestParams, {
      orchestratorHost: process.env.ORCHESTRATOR_HOST,
      useCredentials: process.env.USE_CREDENTIALS === '1',
      apiKey: process.env.API_KEY,
    });
    store.dispatch(FETCH_COLLECTIONS.init, {
      url,
      ...(variantId && { variantId }),
      ...(limit && { limit }),
      ...(landingType && { landingType }),
    });

    const unsub = store.on('@dispatch', state => {
      if (state.collections.loading) {
        return;
      }

      unsub();
      resolve(store.get());
    });
  });
